import { SettingRow } from '@affine/component/setting-components';
import { SubscriptionService } from '@affine/core/modules/cloud';
import { WorkspaceQuotaService } from '@affine/core/modules/quota';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { type ReactElement, useEffect } from 'react';

import { UsageProgress } from '../../account-setting/usage-progress';

export const WorkspaceQuotaPanel = (): ReactElement | null => {
  const t = useI18n();

  const quota = useService(WorkspaceQuotaService).quota;

  useEffect(() => {
    quota.revalidate();
  }, [quota]);

  const maxFormatted = useLiveData(
    quota.maxFormatted$.selector(m => m?.docLimit)
  );
  const usedFormatted = useLiveData(quota.used$.selector(u => u?.usedDocCount));

  const color = useLiveData(quota.color$.selector(c => c?.docQuota));
  const percent = useLiveData(quota.percent$.selector(p => p?.docQuota));

  const subscription = useService(SubscriptionService).subscription;
  useEffect(() => {
    subscription.revalidate();
  }, [subscription]);

  const proSubscription = useLiveData(subscription.pro$);
  const isFreeUser = !proSubscription;

  return (
    <SettingRow name={t['docnboard.doc.title']()} desc="" spreadCol={false}>
      <UsageProgress
        hasPayment={false}
        limit={`${usedFormatted}/${maxFormatted}`}
        percent={percent}
        color={color}
        isFreeUser={isFreeUser}
        title={t['docnboard.doc.used.hint']()}
      />
    </SettingRow>
  );
};
